//export const baseUrl = 'http://api.mercury-server.test/'
export const baseUrl = 'https://api.an-merkuriy.ru'

export const baseTimeout = 60000
